// Picker вкладки «Отчёт» (DocumentsPage): филиал — полный справочник, без привязки к субъекту в карточке.

import { useState, useCallback, useEffect } from 'react';
import { allBranchPickerOptions } from './pickerHooks';

export const useReportFormPicker = (handbooks, formData, setFormData, allowedSubjectIds = null) => {
  const [showPicker, setShowPicker] = useState(false);
  const [pickerField, setPickerField] = useState('');
  const [pickerOptions, setPickerOptions] = useState([]);
  const [pickerValue, setPickerValue] = useState('');
  const [pickerSearch, setPickerSearch] = useState('');
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(-1);

  const openPicker = (fieldName, handbookId) => {
    let options = [];

    if (fieldName === 'filial') {
      options = allBranchPickerOptions(handbooks || []);
    } else {
      const handbook = (handbooks || []).find((h) => h.id === handbookId);
      if (handbook?.references) {
        let refs = handbook.references;
        // Субъект РФ: ограничиваем филиалом пользователя (allowedSubjectIds === null — без ограничения).
        if (fieldName === 'srf' && allowedSubjectIds instanceof Set) {
          refs = refs.filter((r) => allowedSubjectIds.has(String(r.id)));
        }
        options = refs.map((r) => ({
          value: r.id.toString(),
          label: r.name,
          description: r.description || null,
        }));
      }
    }

    if (options?.length > 0) {
      const currentValue = formData[fieldName] || '';
      const isFilial = fieldName === 'filial';
      const selectedIndex = options.findIndex((opt) =>
        isFilial ? opt.label === currentValue : opt.value === currentValue
      );

      setPickerField(fieldName);
      setPickerOptions(options);
      setPickerValue(currentValue);
      setPickerSearch('');
      setSelectedOptionIndex(selectedIndex);
      setShowPicker(true);
      return;
    }

    if (fieldName === 'filial') {
      alert(
        'Справочник филиалов не загружен. Дождитесь загрузки справочников на странице и откройте список снова.'
      );
    } else if (fieldName === 'srf') {
      alert('Справочник субъектов РФ не загружен. Дождитесь загрузки справочников.');
    }
  };

  const closePicker = () => {
    setShowPicker(false);
    setPickerField('');
    setPickerOptions([]);
    setPickerValue('');
    setPickerSearch('');
    setSelectedOptionIndex(-1);
  };

  const selectPickerValue = (value) => {
    const selectedOption = pickerOptions.find((opt) => opt.value === value);
    const valueToSave =
      pickerField === 'filial' && selectedOption ? selectedOption.label : value;

    setFormData({
      ...formData,
      [pickerField]: valueToSave,
    });
    closePicker();
  };

  const getFilteredOptions = useCallback(() => {
    let filtered = pickerOptions;
    if (pickerSearch) {
      filtered = pickerOptions.filter(
        (option) =>
          option.label.toLowerCase().includes(pickerSearch.toLowerCase()) ||
          (option.description &&
            option.description.toLowerCase().includes(pickerSearch.toLowerCase()))
      );
    }
    return filtered.sort((a, b) =>
      a.label.toLowerCase().localeCompare(b.label.toLowerCase(), 'ru')
    );
  }, [pickerOptions, pickerSearch]);

  const getSelectedIndexInFiltered = useCallback(() => {
    if (selectedOptionIndex < 0) return -1;
    const filteredOptions = getFilteredOptions();
    return filteredOptions.findIndex((opt) => opt.value === pickerValue);
  }, [selectedOptionIndex, pickerValue, getFilteredOptions]);

  useEffect(() => {
    if (!showPicker) return;
    const timer = setTimeout(() => {
      const filteredIndex = getSelectedIndexInFiltered();
      if (filteredIndex >= 0) {
        const selectedElement = document.querySelector(
          `.picker-list li:nth-child(${filteredIndex + 1})`
        );
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [showPicker, pickerSearch, selectedOptionIndex, getSelectedIndexInFiltered]);

  return {
    showPicker,
    pickerField,
    pickerOptions,
    pickerValue,
    pickerSearch,
    selectedOptionIndex,
    openPicker,
    closePicker,
    selectPickerValue,
    getFilteredOptions,
    getSelectedIndexInFiltered,
    setPickerSearch,
  };
};
